import { getAuthIdToken } from "@/lib/firebase";
import axios from "axios";
import { ApiError } from "./errors";

/*
    Axios Instance
    You can use this instance to make requests to the server.
*/

const axiosInstance = axios.create({
  baseURL: `${import.meta.env.VITE_AXIOS_URL}`,
  timeout: 300000,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(async (config) => {
  const idToken = await getAuthIdToken();

  if (idToken) {
    try {
      config.headers.Authorization = `Bearer ${idToken}`;
    } catch (error) {
      console.error("Error getting ID token:", error);
    }
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    const dateFields = ["createdAt", "updatedAt"];

    const convertDates = (obj: any) => {
      if (!obj) return obj;
      for (const key of Object.keys(obj)) {
        if (dateFields.includes(key)) {
          obj[key] = new Date(obj[key]);
        }
      }
      return obj;
    };

    response.data = convertDates(response.data);
    return response;
  },
  async (error) => {
    if (!axios.isAxiosError(error) || !error.response) {
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    // blob 응답(responseType: "blob")인 경우 text로 파싱
    let parsed = data;
    if (data instanceof Blob) {
      try {
        parsed = JSON.parse(await data.text());
      } catch {
        return Promise.reject(error);
      }
    }

    if (parsed?.error_code) {
      return Promise.reject(
        new ApiError(parsed.error_code, parsed.message, status),
      );
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
